import 'regenerator-runtime/runtime';

(function(global) {
    // jquery should be before angular
    global.jQuery = global.$ = require('jquery');
    global.moment = require('moment-timezone');
    require('angular');
    global.angular = angular;
})(typeof window !== 'undefined' ? window : {});
